export default __webpack_public_path__ + "static/media/play-badge.1bc6fdd1.svg";